import { useMutation } from "@tanstack/react-query";
import { positionUpdate } from "common/api/unos_rad/unos_position";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constant/react_query";

type UseUnosPositionUpdateParams = {
  invalidateKeys?: string[];
};

export const useUnosPositionUpdate = (
  hookParams?: UseUnosPositionUpdateParams
) => {
  const queryClient = useQueryClient();
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: positionUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await positionUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.UNOS_VIDEO_GET],
        });
      }
    },
  });

  return { positionUpdateMutate };
};
